<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        Modifier PAC (éco-régime)
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="onClose()"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex flex-column mt-6 mx-4">
      <AgrialSelect
        v-model="parametreModifiable.indicateurNonChiffrePAC.nombrePointsPAC"
        :items="valeursPossibles"
        label="Nombre de points"
        hide-details
      />
    </div>
    <div
      class="d-flex flex-column mt-6 mx-4"
    >
      <AgrialInput
        v-model="parametreModifiable.indicateurNonChiffrePAC.libellePAC"
        label="Texte"
        required
      />
    </div>
    <v-card-actions class="pa-4">
      <v-spacer />
      <AgrButton
        color="primary darken-1"
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        color="primary darken-1"
        :disabled="!isValid"
        @click="save()"
      >
        Valider
      </AgrButton>
    </v-card-actions>
  </v-card>
</template>
<script>
import { AgrButton } from '@agrial/ui'
import AgrialInput from '@/components/form/agrial-input.vue'
import AgrialSelect from '@/components/form/agrial-select.vue'
import { mapActions } from 'vuex'
import {clone} from '@/utils/clone'

export default {
  name: 'UpdatePacModal',
  components: {AgrButton, AgrialInput, AgrialSelect},
  props: {
    parametre: {
      type: Object,
      default: null
    },
  },

  data () {
    return {
      valeursPossibles: null,
      parametreModifiable: null
    }
  },

  computed: {
    isValid () {
      return this.parametreModifiable.indicateurNonChiffrePAC.nombrePointsPAC != null
    }
  },

  created () {
    this.parametreModifiable = clone(this.parametre)
    this.valeursPossibles = [0, 1, 2, 3, 4, 5]
    this.parametreModifiable.indicateurNonChiffrePAC.nombrePointsPAC = this.parametre != null ? this.parametre.indicateurNonChiffrePAC.nombrePointsPAC : null
    this.parametreModifiable.indicateurNonChiffrePAC.libellePAC = this.parametre != null ? this.parametre.indicateurNonChiffrePAC.libellePAC : null
  },

  methods: {
    ...mapActions({
      updateAdminComparateurIndicateurNonChiffreMarge: 'comparateurMarge/updateAdminComparateurIndicateurNonChiffreMarge'
    }),
    
    onClose () {
      this.$emit('close')
    },
    save () {
      this.updateAdminComparateurIndicateurNonChiffreMarge(this.parametreModifiable)
      .then(() => this.$emit('updatedParametre'))
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
</style>